import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AuthModel, EXPLICIT_SELECT_ORGANISATION } from "@intocare/auth-data";

@Injectable({
	providedIn: "root",
})
export class SelectOrganisationGuard implements CanActivate {
	private router = inject(Router);
	private authModel = inject(AuthModel);

	canActivate(route: ActivatedRouteSnapshot) {
		const organisation = window.localStorage.getItem("currentOrganisation");
		const { [EXPLICIT_SELECT_ORGANISATION]: explicitSelectOrganisationQueryParam, ...queryParams } = route.queryParams;
		const explicitSelectOrganisation =
			this.router.getCurrentNavigation().extras.state?.[EXPLICIT_SELECT_ORGANISATION]
			|| explicitSelectOrganisationQueryParam;

		if (!explicitSelectOrganisation && organisation) {
			return this.authModel.bootstrapUserPool(organisation).pipe(
				map((config) =>
					this.router.createUrlTree(
						[organisation.split(".").join("/"), config.hostedUiUri ? "sign-in" : "sign-in-with-username"],
						{
							queryParams: { redirectTo: route.queryParams.redirectTo, ...queryParams },
						},
					),
				),
				catchError(() => {
					// Incorrect organisation, remove it from local storage
					this.authModel.removeOrganisation(organisation);
					return of(this.router.createUrlTree(["select-organisation"]));
				}),
			);
		} else {
			return true;
		}
	}
}
